/* eslint-disable @next/next/no-before-interactive-script-outside-document */
/* eslint-disable @next/next/no-document-import-in-page */
/* eslint-disable @next/next/no-title-in-document-head */
import { useMemo } from 'react';

import { useRouter } from 'next/router';
import Head from 'next/head';
import { AppProps } from 'next/dist/shared/lib/router/router';

import { PublicLayout } from '~/layouts/public';
import { PrivateLayout } from '~/layouts/private';
import { AdminLayout } from '~/layouts/admin';

import { ProvidersHOC } from '~/common/providers';
import { sidebarRouteKeys } from '~/common/constants/sidebar';

type LayoutMode = 'default' | 'none';
type AppPageProps = AppProps['pageProps'] & {
  layoutMode?: LayoutMode;
};
type AppPageComponent = AppProps['Component'] & {
  layoutMode?: LayoutMode;
};

const NoLayout = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
);

function MonteiroEngenhariaErpApp({
  Component,
  pageProps,
}: AppProps): JSX.Element {
  const router = useRouter();
  const CurrentComponent = Component as AppPageComponent;
  const resolvedPageProps = pageProps as AppPageProps;
  const Layout = useMemo(() => {
    if (
      CurrentComponent.layoutMode === 'none' ||
      resolvedPageProps.layoutMode === 'none'
    ) {
      return NoLayout;
    }

    if (router.asPath.startsWith('/admin')) {
      return AdminLayout;
    }

    return sidebarRouteKeys.some((key) =>
      router.asPath.replace('/', '').includes(key)
    )
      ? PrivateLayout
      : PublicLayout;
  }, [CurrentComponent.layoutMode, resolvedPageProps.layoutMode, router]);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />

        <meta name="theme-color" content="#ffffff" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon.png" />

        <title>VMCORE | ERP</title>
      </Head>

      <ProvidersHOC>
        <Layout>
          <Component {...pageProps} />
        </Layout>
      </ProvidersHOC>
    </>
  );
}

export default MonteiroEngenhariaErpApp;
